import { ReactNode } from 'react';
import { SeriesItemCardProps } from '../SeriesItemCardProps';
import { ArticleDetail } from '../../../article-detail';
import { Heading } from '../../../../../../_helpers/Heading';
import Eyebrow from '../../../eyebrow/Eyebrow';

import './SeriesItemDataCard.scss';

type SeriesItemDataCardProps = Omit<SeriesItemCardProps, 'changeSavedState'> & {
	children?: ReactNode;
};

const SeriesItemDataCard: React.FC<SeriesItemDataCardProps> = ({
	itemData,
	componentData,
	cardConfig,
	headingLevel,
	children,
}) => {
	return (
		<div className="item-data-container">
			<Eyebrow
				icon={cardConfig.itemTypeIcon || 'fal fa-newspaper'}
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				tag={itemData.eyebrowTag}
			/>

			<Heading headingLevel={headingLevel} className="item-title">
				{itemData.contentTitle}
			</Heading>

			<div className="item-details-container">
				{/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore */}
				<ArticleDetail
					publicationDate={itemData.publicationDate}
					authors={itemData.authors}
					writtenByTranslation={componentData.writtenByLabel}
					className={cardConfig.saveBtnPosition}
				/>

				{/*Place for save button*/}
				{children}
			</div>

			{!cardConfig.descriptionDisabled && (
				<p className="item-description">{itemData.description}</p>
			)}
		</div>
	);
};

export default SeriesItemDataCard;
